import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = { statuses: Object }

  static targets = ["notStarted", "notDone", "done"];

  connect() {
    this.update();
  }

  statusUpdated(event) {
    if (this.statusesValue[event.detail.todoId] != event.detail.done) {
      this.statusesValue = {
        ...this.statusesValue,
        [event.detail.todoId]: event.detail.done,
      };

      this.update();
    }
  }

  update() {
    const { bank_account, ...statuses } = this.statusesValue
    const started = Object.values(statuses).some(done => done);
    const incomplete = Object.values(statuses).some(done => !done);

    for (const el of this.notStartedTargets) {
      el.style.display = !started ? "" : "none";
    }

    for (const el of this.notDoneTargets) {
      el.style.display = started && incomplete ? "" : "none";
    }

    for (const el of this.doneTargets) {
      el.style.display = started && !incomplete ? "" : "none";
    }
  }
}
